import { render, staticRenderFns } from "./MapBlock.vue?vue&type=template&id=6c80c5e8&scoped=true&"
import script from "./MapBlock.vue?vue&type=script&lang=js&"
export * from "./MapBlock.vue?vue&type=script&lang=js&"
import style0 from "./MapBlock.vue?vue&type=style&index=0&id=6c80c5e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c80c5e8",
  null
  
)

export default component.exports